module.exports = __webpack_public_path__ + "static/img/qtcj08.790d104.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qtcj08.png
// module id = 468
// module chunks = 0